import React, {
  Component,
  Fragment
} from 'react';

import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import {
  NavLink
} from 'react-router-dom';

import {
  LogoSection,
  LogoImage,
  NavbarItem,
  NavbarProfileImg,
  NavbarMobile,
  NavbarMobileItems,
  NavbarWrapper
} from '../HelperComponents/StyledComponents';

import { logOutAction } from '../../actions/UserActions';

import LogoImg from '../../images/logo.png';
import personIcon from '../../images/person-icon.png';

class NavbarComponent extends Component {

  static propTypes = {
    user: PropTypes.object,
    dispatch: PropTypes.func,
    history: PropTypes.object
  }

  state = {
    toggleMobileMenu: false
  };


  showMobileMenu =() => {
    this.setState({
      toggleMobileMenu: !this.state.toggleMobileMenu
    });
  }
  closeFilter = () => {
    console.log('closeFilter');
      var delets = document.querySelectorAll('span.tag.is-delete'); 
      for (let i = 0; i < delets.length; ++i) {
        delets[i].click();
      };
  }

  hideMobileMenuOnClick = () => {
    this.setState({toggleMobileMenu: false})
  }


  navbarLink = () => {
    if (this.props.user.authenticated) {
      return (
        <Fragment>
          <NavbarItem className="navbar-item is-hidden-touch">
            <NavLink to="/favorites" exact activeClassName="active" className="icon-heart heart-icon" style={{ color: '#fea67f' }}>
            </NavLink>
          </NavbarItem>

          <NavbarItem className="navbar-item has-text-white" onClick={() => this.props.logOutAction(this.props.history)}>
            <a>Logout</a>
          </NavbarItem>
        </Fragment>
      );
    }
  }

  render() {

    return (
      <Fragment>
        <NavbarWrapper className="navbar is-fixed-top is-black" role="navigation" aria-label="dropdown navigation">
          <section className="navbar-brand">
            <NavbarMobile className="is-hidden-desktop">
              <section className="navbar-item">
               {this.props.user.authenticated &&
                <NavLink to="/" style={{ paddingLeft: '.65rem' }} onClick={this.closeFilter}>
                  <LogoImage src={LogoImg} alt="Voila Logo" width="40" />
                </NavLink>
               }
              </section>

              <NavbarMobileItems>
                {
                  this.props.user.authenticated && <div>
                    <NavbarItem className="navbar-item is-inline is-paddingless">
                      <NavLink to="/favorites" className="icon-heart heart-icon">
                      </NavLink>
                    </NavbarItem>
                  </div>
                }
                <a role="button" className={`navbar-burger has-text-white is-pull-right ${this.state.toggleMobileMenu ? 'is-active' : ''} `} aria-label="menu" aria-expanded="false" onClick={this.showMobileMenu}>
                  <span aria-hidden="true"></span>
                  <span aria-hidden="true"></span>
                  <span aria-hidden="true"></span>
                </a>
              </NavbarMobileItems>
            </NavbarMobile>
          </section>

          <section className={`navbar-menu ${this.state.toggleMobileMenu ? 'is-active' : ''}`} style={{ background: '#000', padding: '0 1em' }} onClick={this.hideMobileMenuOnClick}>
            <section className="navbar-start" style={{ zIndex: 1 }}>
              {
                this.props.user.authenticated &&
                <NavbarItem className="navbar-item is-flex-touch" style={{ justifyItems: 'center', alignItems: 'center'}}>
                  <NavbarProfileImg className="is-inline-block-tablet" >
                    <img src={ this.props.user.image || personIcon } className="is-rounded" alt="Profile" />
                  </NavbarProfileImg>
                  <NavLink to="/profile" activeClassName="active" className=" is-inline-touch is-capitalized">
                    {this.props.user.data.user_display_name}
                  </NavLink>
                </NavbarItem>
              }
            </section>
            <LogoSection className="navbar-center has-text-centered is-hidden-touch">
             {this.props.user.authenticated &&
              <NavLink to="/" className="has-text-white is-size-3 is-uppercase" onClick={this.closeFilter} >
                <LogoImage src={LogoImg} alt="Voila Logo" width="60"/>
              </NavLink>
             }
            </LogoSection>
            <section className="navbar-end">
              {this.navbarLink()}
            </section>
          </section>
        </NavbarWrapper>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state;
  const {
    isFetching,
    lastUpdated,
  } = user || {
    isFetching: true,
    authenticated: false
  };

  return {
    user,
    isFetching,
    lastUpdated
  };
}

export const Navbar = withRouter(connect(mapStateToProps, { logOutAction })(NavbarComponent));


// WEBPACK FOOTER //
// ./src/components/Navbar/Navbar.js